module.exports = __webpack_public_path__ + "static/media/SherlockBonesSeaCreature.24d61a6a.jpg";